import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'react-bootstrap';

const ButtonCustom = ({ 
  onClick, 
  children, 
  type, 
  color, 
  loading, 
  extraClass, 
  ...props 
}) => {
  const styleBtn = `bg-${color}-color`;
  const styleBtnDisabled = `${loading && 'custom-disabled'} `;

  return (
    <Button type={type} onClick={onClick} className={`btn-intra ${extraClass} ${styleBtn} ${styleBtnDisabled}`} disabled={loading} {...props}>
      {children}
    </Button>
  );
};

ButtonCustom.propTypes = {
  loading: PropTypes.bool,
  children: PropTypes.any,
  onClick: PropTypes.func,
  type: PropTypes.string,
  color: PropTypes.oneOf(['primary', 'secondary', 'terciary']),
  disabled: PropTypes.bool,
  extraClass: PropTypes.string,
};

export default ButtonCustom;
